import React from 'react';
import styled from 'styled-components';

const ContentWrapper = styled.div`
	width: 80%;
	margin: 0 auto;
`;

const ContentSection = styled.section`
	background-color: #3f3d3d;
	color: #fff;
	border-radius: 10px;
	padding: 4em 2em;

    a {
        text-decoration: underline;
    }
`;

const ContentHeader = styled.h1`
	padding-bottom: 30px;
`;

const WhatNext = () => {
	return (
		<section id="what-next">
			<div className="container container--md">
				<ContentWrapper>
					<ContentHeader>What Next?</ContentHeader>
					<ContentSection>
						<div>
							<p>
								My World of Bags is equipped with a factory and the skilled manpower to mass produce premium
								quality Personal Protective Equipment to unique specifications for medical and non-medical
								personnel alike. <br />
								<br />
								We currently work with 52 partner organisations across Lagos and Ibadan, who have collectively
								supported our ability to provide well-designed and durable items for optimal protection; if your
								organisation would like to partner with us on the production of PPE, we would love to hear from
								you.
								<br />
								<br />
								Is your organisation in need of PPE? Though the charity element of the project has now concluded,
								we are keen to lend our expertise to meeting your organisation’s needs - in and beyond the
								COVID-19 pandemic. Our <a href="mailto:info@myworldofbags.com">sales team</a> is available to discuss.
							</p>
						</div>
					</ContentSection>
				</ContentWrapper>
			</div>
		</section>
	);
};

export default WhatNext;
